import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN, INDEX_MAIN_PAGE_PATH, APPID } from '@/store/mutation-types'
import { generateIndexRouter, getUrlParam } from '@/utils/util'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/user/register', '/user/register-result', '/user/alteration'] // no redirect whitelist
function setToken() {
  let token = Vue.ls.get(ACCESS_TOKEN)
  let urlToken = getUrlParam('token')
  if (!token || token != urlToken) {
    if (urlToken) {
      Vue.ls.set(ACCESS_TOKEN, urlToken, 7 * 24 * 60 * 60 * 1000)
      store.commit('SET_PERMISSIONLIST', [])
    }
  }
  let urlAppid = getUrlParam('appid')
  if (urlAppid) {
    urlAppid = urlAppid.substring(0, 5)
    Vue.ls.set(APPID, urlAppid, 7 * 24 * 60 * 60 * 1000)
  }
}
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  setToken()
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ path: INDEX_MAIN_PAGE_PATH })
      NProgress.done()
    } else {
      if (store.getters.permissionList.length === 0) {
        store
          .dispatch('GetPermissionList')
          .then((res) => {
            const menuData = res.result.menu
            console.log(res.message)
            if (menuData === null || menuData === '' || menuData === undefined) {
              return
            }
            let constRoutes = []
            constRoutes = generateIndexRouter(menuData)
            // 添加主界面路由
            store.dispatch('UpdateAppRouter', { constRoutes }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.addRouters)
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
          })
          .catch(() => {
            store.dispatch('Logout').then(() => {
              next(false)
              window.location.href = window._CONFIG['authUrl']
              // next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next(false)
      message.warning('登录出现异常,页面即将跳转尝试重新登录', 2).then(() => {
        window.location.href = window._CONFIG['authUrl'] + '?logout=true'
      })
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
